import * as React from "react";
import Svg, { Path } from "react-native-svg";
function InfoImage(props) {
    return (React.createElement(Svg, { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M10 18.334c4.6 0 8.334-3.734 8.334-8.334s-3.733-8.333-8.333-8.333A8.336 8.336 0 001.667 10c0 4.6 3.734 8.334 8.334 8.334z", fill: "#667085" }),
        React.createElement(Path, { d: "M10.093 6.667a.74.74 0 100 1.481.74.74 0 000-1.481zM10.093 13.334c.408 0 .741-.334.741-.741V9.63a.743.743 0 00-.74-.741.743.743 0 00-.742.74v2.964c0 .407.334.74.741.74z", fill: "#fff" })));
}
export default InfoImage;
